/* RESPONSIBLE TEAM: team-conversational-knowledge */
import Model, { attr, belongsTo } from '@ember-data/model';
import type AiContentSegment from 'embercom/models/ai-content-segment';

export default class SuggestionSegmentationRule extends Model {
  @attr('string') declare title: string;
  @attr('string') declare aiContentSegmentId: string;
  @attr('string') declare brandId: string;

  @belongsTo('ai-content-segment', { async: false })
  declare aiContentSegment?: AiContentSegment;
}
